import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text from '../Text';
import Styles from './ContinueBuyButton.styles';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const ContinueBuyWrapper = styled.div`${Styles.continueBuyWrapper}`; // prettier-ignore
const Cancel = styled.div`${Styles.cancel}`; // prettier-ignore
const Continue = styled.div`${Styles.continue}`; // prettier-ignore
const Buy = styled.div`${Styles.buy}`; // prettier-ignore
const BuyPercentage = styled.div`${Styles.buyPercentage}`; // prettier-ignore
const BuyLabel = styled(Text)`${Styles.buyLabel}`; // prettier-ignore

/**
 * ContinueBuyButton component
 * @param {string} props.continueLabel - continue label
 * @param {string} props.buyLabel - buy label
 * @returns {JSX}
 */
const ContinueBuyButton = ({
  className,
  cancelLabel,
  continueLabel,
  buttonAction,
  isBuying,
  isCancel,
  buyLabel,
  progress,
  disableButton
}) => {
  return (
    <Wrapper
      className={className}
      onClick={!disableButton ? buttonAction : undefined}
      disableButton={disableButton}
    >
      <ContinueBuyWrapper isBuying={isBuying} isCancel={isCancel}>
        <Cancel>{cancelLabel}</Cancel>
        <Continue>{continueLabel}</Continue>
        <Buy>
          <BuyLabel>{buyLabel}</BuyLabel>
          <BuyPercentage progress={progress} />
        </Buy>
      </ContinueBuyWrapper>
    </Wrapper>
  );
};

ContinueBuyButton.propTypes = {
  className: PropTypes.string,
  continueLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  buyLabel: PropTypes.string,
  buttonAction: PropTypes.func.isRequired,
  isBuying: PropTypes.bool,
  isCancel: PropTypes.bool,
  progress: PropTypes.number,
  disableButton: PropTypes.bool
};

export default ContinueBuyButton;
